import { CaseForm } from 'queries/cases/types';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { EvidenceContent } from './components/EvidenceContent/EvidenceContent';
import './Evidences.scss';

interface Props {
  fileInputRef: React.RefObject<HTMLInputElement>;
}

export const Evidences = ({ fileInputRef }: Props) => {
  const formMethods = useFormContext<CaseForm>();
  const { formState, watch } = formMethods;
  const isLoading = formState.isSubmitting || formState.isLoading;
  const evidences = watch('evidences') || [];
  const asset = watch('asset');
  const assetId = asset?.id ?? '';

  return (
    <EvidenceContent
      isLoading={isLoading}
      assetId={assetId}
      evidences={evidences}
      fileInputRef={fileInputRef}
      handleSubmit={formMethods.handleSubmit}
    />
  );
};
